import { CalendarClock, Car, User, X, Loader2 } from 'lucide-react';
import { CandidateSlot } from '../types';
import { durationLabel, slotLabel } from '../lib/format';

export default function ReserveModal({
  slot,
  schoolName,
  submitting,
  error,
  onConfirm,
  onClose,
}: {
  slot: CandidateSlot;
  schoolName: string | null;
  submitting: boolean;
  error: string | null;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[85vh] overflow-y-auto pointer-events-auto">
          <div className="flex items-start justify-between p-6 pb-4">
            <div>
              <h3 className="font-semibold text-slate-900">
                Confirmer la réservation
              </h3>
              <p className="text-sm text-slate-500 mt-0.5">
                Leçon de conduite{schoolName ? ` · ${schoolName}` : ''}
              </p>
            </div>
            <button
              onClick={onClose}
              className="p-1.5 rounded-lg hover:bg-slate-100 transition-colors"
              aria-label="Fermer"
            >
              <X size={18} className="text-slate-400" />
            </button>
          </div>
          <div className="px-6 pb-6 space-y-4">
            <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 space-y-3">
              <div className="flex items-center gap-3">
                <CalendarClock
                  size={16}
                  className="text-indigo-600 flex-shrink-0"
                />
                <span className="text-sm font-semibold text-slate-900">
                  {slotLabel(slot.startsAt, slot.endsAt)}
                </span>
              </div>
              <div className="flex items-center gap-3">
                <User size={16} className="text-indigo-600 flex-shrink-0" />
                <span className="text-sm text-slate-700">
                  Moniteur :{' '}
                  <span className="font-semibold text-slate-900">
                    {slot.instructorName ?? 'À confirmer'}
                  </span>
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Car size={16} className="text-indigo-600 flex-shrink-0" />
                <span className="text-sm text-slate-700">
                  {durationLabel(slot.startsAt, slot.endsAt)} · Décomptée de
                  votre forfait
                </span>
              </div>
            </div>
            <p className="text-sm text-slate-600">
              Votre réservation sera confirmée instantanément et votre moniteur
              sera prévenu.
            </p>
            {error && (
              <p className="text-sm text-red-600" role="alert">
                {error}
              </p>
            )}
            <div className="flex gap-3 pt-1">
              <button
                onClick={onClose}
                className="flex-1 px-4 py-2.5 border border-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors text-sm font-medium"
              >
                Annuler
              </button>
              <button
                onClick={onConfirm}
                disabled={submitting}
                className="flex-1 flex items-center justify-center gap-2 px-4 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 text-white text-sm font-semibold rounded-lg shadow-sm transition-colors"
              >
                {submitting && <Loader2 size={16} className="animate-spin" />}
                Confirmer
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
